<template>
  <v-dialog v-model="dialog" :fullscreen="zoomStatus" persistent scrollable max-width="1200px">
    <v-card>
      <!-- Full screen -->
      <v-toolbar v-if="zoomStatus" dark color="primary">
        <v-toolbar-title>
          <span>
            Biểu đồ giá
            <span v-if="matHangShowChart.market_product" class="font-weight-bold">
              {{ matHangShowChart.market_product.name }}
            </span>
            trong năm
            <span class="font-weight-bold">
              {{ nam }}
            </span>
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn text @click="zoom">
            Thu nhỏ
          </v-btn>
          <v-btn text @click="close">
            Đóng lại
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- Default screen -->
      <v-card-title v-if="!zoomStatus">
        <span>
          Biểu đồ giá
          <span v-if="matHangShowChart.market_product" class="font-weight-bold">
            {{ matHangShowChart.market_product.name }}
          </span>
          trong năm
          <span class="font-weight-bold">
            {{ nam }}
          </span>
        </span>
        <v-spacer />
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="close()" color="primary">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text class="px-4 mb-6" :class="[zoomStatus ? 'fullHeight' : '']">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-card flat>
              <v-card-text class="py-0">
                <v-radio-group v-model="typeLoadChart" row hide-details>
                  <v-radio label="Theo tháng" value="month" />
                  <v-radio label="Theo tuần" value="week" />
                  <v-radio label="Cùng kỳ năm trước" value="year" />
                </v-radio-group>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div v-if="loading" class="text-center">
              <v-progress-circular indeterminate size="50" />
              <h4 class="my-2">Đang chuẩn bị dữ liệu</h4>
            </div>
            <div v-else class="chart-wrapper">
              <div class="legend-con" v-html="message"></div>
              <MarketBarChart :chart-data="datacollection" :filter="typeLoadChart" @finish="onFinishRender"
                @generated="setLegend" :data="data" />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions v-if="!zoomStatus">
        <v-spacer />
        <v-btn color="primary darken-1" text @click="zoom()">
          Phóng to
        </v-btn>
        <v-btn color="pink darken-1" text @click="close()">
          Đóng lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import MarketBarChart from '@/components/public/market/MarketBarChart';
import moment from 'moment';
export default {
  components: {
    MarketBarChart
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    matHangShowChart: {
      type: Object,
      default: {}
    },
    namShowChart: {
      type: String,
      default: null
    },
    date: {
      type: String,
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      dialogFilter: false,
      errors_exist: false,
      errors: [],
      data: [],
      datacollection: {},
      matHangId: 0,
      nam: '',
      typeLoadChart: "month",
      findByWeek: false,
      minRange: 1,
      maxRange: moment().isoWeeksInYear(),
      rangeWeek: [1, 52],
      rangeRule: [
        v => !!v || "Không được để trống",
        v => (v && v <= moment().isoWeeksInYear()) || "Không lớn hơn số tuần",
        v => (v && v >= 1) || "Không nhỏ hơn 1",
      ],
      weekOption: null,
      years: [],
      yearSelected: null,
      zoomStatus: false,
      message: null
    }
  },
  mounted() {
    this.dialog = this.showDialog;
  },
  watch: {
    showDialog() {
      this.dialog = false;
      if (this.showDialog) {
        this.dialog = true;
        this.typeLoadChart = "month";
        this.matHangId = parseInt(this.matHangShowChart.mathang_id);
        this.nam = this.namShowChart;
        this.weekOption = {
          startWeek: this.rangeWeek[0],
          endWeek: this.rangeWeek[1]
        }
        this.loading = true;
        this.getData();
        this.getAllNamFromMarket();
      }
    },
    typeLoadChart(newValue) {
      this.loading = true;
      if (newValue == 'week')
        this.findByWeek = true;
      this.findByWeek = false;

      if (!this.findByWeek)
        this.getData();
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.zoomStatus = false;
      this.$emit('cancelled');
    },
    zoom() {
      this.zoomStatus = !this.zoomStatus;
    },
    onFinishRender() {
      this.loading = false;
    },
    setWeekOption() {
      this.findByWeek = true;
      this.weekOption = {
        startWeek: this.rangeWeek[0],
        endWeek: this.rangeWeek[1]
      };
      this.getData();
    },
    getData() {
      const app = this;
      let route = "get-market-chart";
      let request = {
        params: {}
      };
      if (app.typeLoadChart == 'week') {
        route = "get-market-chart-by-week";
        request = {
          params: {
            weekRange: app.weekOption
          }
        };
      }
      if (app.typeLoadChart == 'year') {
        route = "get-market-chart-by-years";
        request = {
          params: {
            ngay: app.date.substr(0, 2),
            thang: app.date.substr(2, 2)
          }
        };
      }
      axios.get(`api/v1/public/${route}/${app.matHangId}/${app.nam}`, request)
        .then(response => {
          app.data = response.data;
          app.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          app.loading = false;
        });
    },
    getAllNamFromMarket() {
      axios.get("api/v1/public/get-all-year-from-market")
        .then(response => {
          this.years = response.data.slice(1);
          this.yearSelected = response.data[1];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setLegend(html) {
      this.message = html
    }
  }
}
</script>
<style>
.v-input__slider .v-input__control {
  margin-top: 8px !important;
}

.fullHeight {
  height: 100vh;
}

.chart-wrapper {
  height: 100%;
  width: 100%;
}

.legend-con {
  font-family: Roboto;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.legend-con ul {
  list-style: none;
}

.legend-con li {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.legend-con li span {
  display: inline-block;
}

.legend-con li span.chart-legend {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

[class$="-legend"] {
  list-style: none;
  cursor: pointer;
  padding-left: 0;
}

[class$="-legend"] li {
  display: inline;
  padding: 0 5px;
}

[class$="-legend"] li.hidden {
  text-decoration: line-through;
}

[class$="-legend"] li span {
  display: inline-block;
  margin-right: 10px;
  width: 20px;
}

[class$="-legend"] li span.bar {
  height: 10px;
}

[class$="-legend"] li span.line {
  height: 2px;
}
</style>